// @flow

export type Technology = {
  name: string,
  lightIcon: string,
  darkIcon: string,
  detailImage: string,
};

export const byName = (
  haystack: Technology[],
  needle: string,
): Technology | null => haystack.find(({ name }) => name === needle) || null;
